import { useIdentifyUser } from './useIdentifyUser'

export const SessionAnalytics = () => {
  useIdentifyUser()
  return null
}
